import { useEffect, useState, useLayoutEffect } from 'react'
import './App.css'
import { ReactComponent as Arrow } from './imgs/arrow.svg'
import hand from './imgs/hand.png'
// const env = window.ww;
// const { isWeChat, isWeCom } = env;

const isWeChat = /MicroMessenger/i.test(window.navigator.userAgent)
const isWeCom = /wxwork/i.test(window.navigator.userAgent)

const isMobile = Boolean(
  window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  ))


const hxkt = {
  appName: '嗨学课堂',
  appShortName: '嗨学',
  logo: 'https://assets.haixue.com/prod/fe-react-h5-open-app/hxkt/logo.svg',
  pcLogo: 'https://assets.haixue.com/prod/fe-react-h5-open-app/hxkt/pcLogo.png',
  bgImg: 'https://assets.haixue.com/prod/fe-react-h5-open-app/hxkt/bg.png',
  pcBg: 'https://assets.haixue.com/prod/fe-react-h5-open-app/hxkt/pcBg.png',
  themColor: ['51,119,255'],
  iosLinkUrl:
    'https://apps.apple.com/cn/app/%E5%97%A8%E5%AD%A6%E8%AF%BE%E5%A0%82/id1073018397',
  androidLinkUrl: 'https://mobiledown.highso.com.cn/apk/Haixue.apk',
}

function setImgColor(color) {
  document.querySelector('.arrow path').setAttribute('stroke', color)
  document.querySelector('.arrow polygon').setAttribute('fill', color)
}

function getUrlParams(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false
}

function setTheme(firstColor, secondColor, appInfo) {
  if (isMobile) {
    document
      .querySelector('.root')
      .setAttribute('style', `background-image:url(${appInfo.bgImg})`)
    if (secondColor) {
      document
        .querySelector('.openBtn')
        .style.setProperty(
          '--bg-downLoadBtn',
          `linear-gradient(270deg, rgba(${firstColor}, 1) 0%, rgba(${secondColor}, 1) 100%)`
        )
    } else {
      document
        .querySelector('.openBtn')
        .setAttribute('style', `background:rgba(${firstColor},1);`)
    }
    document
      .querySelector('.downLoadBtn')
      .setAttribute(
        'style',
        `background-color:rgba(${firstColor},.1);color:rgba(${firstColor});`
      )
    ;[...document.querySelectorAll('.sort')].map((item) => {
      item.setAttribute(
        'style',
        `background-color:rgba(${firstColor},.1);color:rgba(${firstColor});`
      )
    })
  } else {
    document
      .querySelector('.pc_root')
      .setAttribute('style', `background-image:url(${appInfo.pcBg})`)
    document
      .querySelector('.pc_qrcode')
      .setAttribute('style', `border-color:rgba(${firstColor},.2)`)
    document
      .querySelector('.pc_text')
      .style.setProperty(
        '--bg-linear',
        `linear-gradient(270deg, rgba(${firstColor}, 0.06) 0%, rgba(${firstColor}, 0.2) 100%)`
      )
  }
}

function getShareConfigData(appData) {
  const urlType = getUrlParams('type')
  const courseType = getUrlParams('courseType')
  const pageTypeConfig = {
    knLive: 1,
    knVideo: 2,
    knTaskDetail: 3,
    groupChat: 4,
    knPaper: 7,

  }
  let renderType = pageTypeConfig[urlType];
  // 直播课后作业
  if (urlType === "knHomework" && courseType == 1) {
    renderType = 5
  }
  // 录播课后作业
  if (urlType === "knHomework" && courseType == 2) {
    renderType = 6
  }

  const businessId =
    getUrlParams('liveId') ||
    getUrlParams('videoId') ||
    getUrlParams('knTaskId') ||
    getUrlParams('groupImId') ||
    getUrlParams('paperId') ||
    getUrlParams('courseId') 

  const { pathname } = new URL(window.location.href)
  const location = window.location
  const app = pathname.split('/').reverse()[0]
  return new Promise((resolve) => {
    if (app === 'hxkt') {
      resolve({
        title: `${appData.appName}APP下载`, // 分享标题
        desc: `${appData.appName}-${
          new Date().getFullYear() +
          '年一级建造师二级建造师中级安全工程师课程题库'
        }`, // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: `https://assets.haixue.com/prod/fe-react-h5-open-app/hxkt/shareLogo.png`, // 分享图标(目前只要嗨学, 精进不用管)
      })
    }
    if (app === 'jjxt') {
      const defaultConfig = {
        title: `打开精进App`, // 分享标题
        desc: `点击开始学习`, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: `https://assets.haixue.com/prod/fe-react-h5-open-app/jjxt/shareLogo.png`, // 分享图标(目前只要嗨学, 精进不用管)
      }
      if (!businessId) {
        resolve(defaultConfig)
      } else {
        let hostUrl = 'https://www.haixue.com'
        if (!location.href.includes('localhost')) {
          hostUrl = new URL(location.href).origin
        }
        fetch(
          `${hostUrl}/upbase/common/appDownloadPageInfo/v1/renderOverseeingStudentCard?renderType=${renderType}&businessId=${businessId}`
        )
          .then((response) => response.json())
          .then((res) => {
            const { title, description, icon } = res.data || {}
            if (res.code === 200 && res.data) {
              resolve({
                title,
                desc: description,
                imgUrl: icon,
                link: window.location.href,
              })
            } else {
              resolve(defaultConfig)
            }
          })
      }
    }
  })
}

function fetchAppInfo() {
  return new Promise((resolve) => {
    // 默认不带参数默认打开嗨学课堂首页
    const { pathname } = new URL(window.location.href)
    const app = pathname.split('/').reverse()[0]
    const pageType = getUrlParams('type') || 'index'
    const location = window.location
    window.gio('track', 'h5_open_app', {
      app: app || 'hxkt',
      pageType,
    })
    if (app) {
      let hostUrl = 'https://www.haixue.com'
      if (!location.href.includes('localhost')) {
        hostUrl = new URL(location.href).origin
      }
      fetch(
        `${hostUrl}/upbase/common/appDownloadPageInfo/v1/getByCode?appIdCode=${app}&url=${encodeURIComponent(
          location.href
        )}`
      )
        .then((response) => response.json())
        .then(resolve)
    } else {
      resolve({ data: hxkt })
    }
  })
}

function App() {
  const [appInfo, setAppInfo] = useState({ themColor: [] })
  const [wxAppId, setWxAppId] = useState(null)

  const corpId = 'ww959b017aac8aedcc'

  useLayoutEffect(() => {
    if (appInfo.themColor.length > 0) {
      const { themColor } = appInfo
      const [firstColor, secondColor] = themColor
      setTheme(firstColor, secondColor, appInfo)
    }
  }, [appInfo])

  const getConfigSignature = () => {
    return new Promise((resolve) => {
      // 默认不带参数默认打开嗨学课堂首页
      const { pathname } = new URL(window.location.href)
      const app = pathname.split('/').reverse()[0]
      const location = window.location

      if (app) {
        let hostUrl = 'https://www.haixue.com'
        if (!location.href.includes('localhost')) {
          hostUrl = new URL(location.href).origin
        }
        fetch(
          `${hostUrl}//upbase/common/wxCorp/getCorpSignature?corpId=${corpId}&currentUrl=${encodeURIComponent(
            location.href
          )}`
        )
          .then((response) => response.json())
          .then((response) => resolve(response.data.corpSignature))
      }
    })
  }

  useEffect(() => {
    // const { pathname } = new URL(window.location.href)
    // const app = pathname.split('/').reverse()[0]
    fetchAppInfo().then(({ data }) => {
      const { themColor, jsApiSignature, wxAppId } = data;
      const location = window.location;
      setWxAppId(wxAppId)
      const [firstColor] = themColor
      const { signature, nonceStr, timestamp, appId } = jsApiSignature || {}
      setAppInfo(data)
      document.title = `${data.appName}APP`
      isWeChat && setImgColor(`rgba(${firstColor},1)`)
      // 在微信内执行
      if (isMobile && isWeChat) {
        const wx = window.wx
        const ww = window.ww
        if (isWeChat && !isWeCom) {
          wx.config({
            debug: location.href.includes('debug'), // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId, // 必填，公众号的唯一标识(精进学堂)
            signature,
            nonceStr,
            timestamp,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['wx-open-launch-app'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          })
          getShareConfigData(data).then((shareConfig) => {
            wx.ready(function () {
              wx.updateTimelineShareData(shareConfig)
              wx.updateAppMessageShareData(shareConfig)
            })
          })
          wx.error(function (res) {
            console.log(JSON.stringify(res), '====>')
          })
        }
        // 企微分享只能线上测试, 企业ID 写死的线上
        if (isWeCom) {
          const location = window.location
          getShareConfigData(data).then((shareConfig) => {
            ww.register({
              corpId,
              jsApiList: ['onMenuShareAppMessage'],
              getConfigSignature,
              onConfigSuccess(val) {
                location.href.includes('debug') &&
                  alert(JSON.stringify({ ...val, type: 'success' }))
              },
              onConfigFail(val) {
                location.href.includes('debug') &&
                  alert(JSON.stringify({ ...val, type: 'failed' }))
              },
              onConfigComplete(val) {
                location.href.includes('debug') &&
                  alert(JSON.stringify({ ...val, type: 'complete' }))
              },
            })
            ww.onMenuShareAppMessage({
              ...shareConfig,
              fail() {
                location.href.includes('debug') && alert('分享失败')
              },
              success() {
                location.href.includes('debug') && alert('用户确认分享后回调')
              },
              cancel() {
                location.href.includes('debug') && alert('用户取消分享后回调')
              },
            })
          })
        }
      }
    })
    if (
      !isMobile &&
      document.querySelector('#downLoadUrl').childNodes.length === 0
    ) {
      let QRCode = window.QRCode
      new QRCode(document.getElementById('downLoadUrl'), {
        text: window.location.href,
        width: 210,
        height: 210,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      }) // 设置要生成二维码的链接
    }
  }, [])

  // 进来就打开APP
  useEffect(() => {
    if (appInfo.themColor.length > 0) {
      if (!isWeChat) {
        openApp()
      }
    }
  }, [appInfo])

  const openApp = () => {
    const { search, pathname } = new URL(window.location.href)
    const app = pathname.split('/').reverse()[0]
    const pageType = getUrlParams('type') || 'index'
    window.gio('track', 'h5_open_app', {
      app: app || 'hxkt',
      pageType,
    })
    window.location.href = `${app}://${app}/app${search}`
  }

  function appDown() {
    var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    if (isiOS) {
      window.location.href = appInfo.iosLinkUrl
    } else if (isAndroid) {
      window.location.href = appInfo.androidLinkUrl
    }
  }

  const _renderH5 = () => {
    const { search, pathname } = new URL(window.location.href)
    const app = pathname.split('/').reverse()[0]
    const extendInfo = `${app}://${app}/app${search}`

    return (
      <div className="root">
        {isWeChat && (
          <div className="header">
            <Arrow className="arrow" />
            <div className="title">温馨提示</div>
            <div className="infoItem">
              <div className="sort">1</div>
              <div className="text"> 点击右上角“…”</div>
            </div>
            <div className="infoItem">
              <div className="sort">2</div>
              <div className="text">选择“浏览器”打开</div>
            </div>
          </div>
        )}

        <img
          className="logo"
          style={{ marginTop: isWeChat ? 12 : 82 }}
          src={appInfo.logo}
        />
        {appInfo?.themColor.length > 0 && wxAppId && (
          <div className="btns">
            {isWeChat ? (
              <div className="openApp">
                <div
                  className="openBtn"
                  style={{
                    color: appInfo?.themColor[0],
                    backgroundColor: `rgba(${appInfo?.themColor[0]},.1)`,
                  }}
                >
                  打开{appInfo.appShortName}{' '}
                </div>
                <wx-open-launch-app
                  appid={wxAppId}
                  extinfo={extendInfo}
                  id="wxTag"
                >
                  <script
                    type="text/wxtag-template"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                    }}
                  >
                    <button
                      id="myBtn"
                      style={{
                        opacity: 0,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        background: 'red',
                        height: '100%',
                      }}
                    ></button>
                  </script>
                </wx-open-launch-app>
              </div>
            ) : (
              <div
                className="openBtn"
                onClick={openApp}
                style={{ color: appInfo?.themColor[0] }}
              >
                打开{appInfo.appShortName}{' '}
              </div>
            )}
            <div className="downLoadBtn" onClick={appDown}>
              立即下载
            </div>
          </div>
        )}
      </div>
    )
  }

  const _renderPc = () => {
    return (
      <div className="pc_root">
        <img className="pc_logo" src={appInfo.pcLogo} />
        <div className="pc_qrcode">
          <div id="downLoadUrl"></div>
        </div>
        <div className="pc_downLoad">
          <div className="pc_text">扫描二维码下载APP</div>
          <img className="pc_hand" src={hand} />
        </div>
      </div>
    )
  }

  return isMobile ? _renderH5() : _renderPc()
}

export default App
